
import React, { useContext } from 'react';
import { AppContext, Screen } from '../context/AppContext';
import { DashboardIcon, OrderIcon, AccountIcon, ChartBarIcon, DeliveryIcon } from './icons';

const LivreurBottomNav: React.FC = () => {
    const { view, setView } = useContext(AppContext);

    const navItems: { screen: Screen; label: string; icon: React.ElementType }[] = [
        { screen: 'livreurDashboard', label: 'Dashboard', icon: DashboardIcon },
        { screen: 'livreurHome', label: 'Missions', icon: DeliveryIcon },
        { screen: 'livreurOrders', label: 'Historique', icon: OrderIcon },
        { screen: 'livreurAccounting', label: 'Compta', icon: ChartBarIcon },
        { screen: 'livreurAccount', label: 'Profil', icon: AccountIcon },
    ];

    return (
        <nav className="fixed bottom-0 left-0 right-0 bg-white shadow-[0_-2px_10px_rgba(0,0,0,0.1)] z-50">
            <div className="flex justify-around max-w-lg mx-auto">
                {navItems.map((item) => (
                    <button
                        key={item.screen}
                        onClick={() => setView({ screen: item.screen })}
                        className={`flex flex-col items-center justify-center w-full pt-2 pb-1 transition-colors duration-200 ${view.screen === item.screen ? 'text-red-600' : 'text-gray-500 hover:text-red-500'
                            }`}
                    >
                        <item.icon className="w-6 h-6 mb-1" />
                        <span className="text-[10px] uppercase font-bold tracking-wide">{item.label}</span>
                        {view.screen === item.screen && (
                            <div className="w-8 h-1 bg-red-600 rounded-full mt-1"></div>
                        )}
                    </button>
                ))}
            </div>
        </nav>
    );
};

export default LivreurBottomNav;
